// NOTE: This file is used in the web canvas editor. It only needs to expose
// animation type constants and default configuration values so the UI can
// configure animations. All runtime animation implementation is handled
// elsewhere (e.g. CSS / web animations), so we intentionally avoid importing
// any native animation libraries here.

// import { Easing } from '@react-spring/web';

export const Entrance_Animations = {
    FADE_IN: 'fadeIn',
    SLIDE_UP: 'slideUp',
    SLIDE_DOWN: 'slideDown',
    SLIDE_LEFT: 'slideLeft',
    SLIDE_RIGHT: 'slideRight',
    SCALE_IN: 'scaleIn',
    BOUNCE_IN: 'bounceIn',
    ROTATE_IN: 'rotateIn',
    FLIP_IN: 'flipIn',
    ZOOM_IN: 'zoomIn'
}
export const Continuous_Animations = {
    FLOAT: 'float',
    PULSE: 'pulse',
    ROTATE: 'rotate',
    BOUNCE: 'bounce',
    SHAKE: 'shake',
    WAVE: 'wave',
    HEARTBEAT: 'heartbeat',
    FLASH: 'flash',
    SWING: 'swing',
    TADA: 'tada'
}
export const Advanced_Animations = {
    MORPH: 'morph',
    GLOW: 'glow',
    SHIMMER: 'shimmer',
    PARTICLE: 'particle',
    MAGNETIC: 'magnetic',
    ELASTIC: 'elastic',
    STAGGER: 'stagger',
    CASCADE: 'cascade',
    SPIRAL: 'spiral',
    ORBIT: 'orbit'
}
export const Special_Animations = {
    NEON: 'neon',
    HOLOGRAM: 'hologram',
    GLITCH: 'glitch',
    MATRIX: 'matrix',
    FIRE: 'fire',
    WATER: 'water',
    SMOKE: 'smoke',
    SPARKLE: 'sparkle',
    RAINBOW: 'rainbow',
    GALAXY: 'galaxy'
}

// Animation Types for Different Elements
export const ANIMATION_TYPES = {
    // Entrance Animations
    FADE_IN: 'fadeIn',
    SLIDE_UP: 'slideUp',
    SLIDE_DOWN: 'slideDown',
    SLIDE_LEFT: 'slideLeft',
    SLIDE_RIGHT: 'slideRight',
    SCALE_IN: 'scaleIn',
    BOUNCE_IN: 'bounceIn',
    ROTATE_IN: 'rotateIn',
    FLIP_IN: 'flipIn',
    ZOOM_IN: 'zoomIn',

    // Continuous Animations
    FLOAT: 'float',
    PULSE: 'pulse',
    ROTATE: 'rotate',
    BOUNCE: 'bounce',
    SHAKE: 'shake',
    WAVE: 'wave',
    HEARTBEAT: 'heartbeat',
    FLASH: 'flash',
    SWING: 'swing',
    TADA: 'tada',

    // Advanced Animations
    MORPH: 'morph',
    GLOW: 'glow',
    SHIMMER: 'shimmer',
    PARTICLE: 'particle',
    MAGNETIC: 'magnetic',
    ELASTIC: 'elastic',
    STAGGER: 'stagger',
    CASCADE: 'cascade',
    SPIRAL: 'spiral',
    ORBIT: 'orbit',

    // Special Effects
    NEON: 'neon',
    HOLOGRAM: 'hologram',
    GLITCH: 'glitch',
    MATRIX: 'matrix',
    FIRE: 'fire',
    WATER: 'water',
    SMOKE: 'smoke',
    SPARKLE: 'sparkle',
    RAINBOW: 'rainbow',
    GALAXY: 'galaxy'
};

// Animation Configurations
export const ANIMATION_CONFIGS = {
    [ANIMATION_TYPES.FADE_IN]:     { duration: 1600, easing: 'ease-out',      delay: 0 },
    [ANIMATION_TYPES.SLIDE_UP]:    { duration: 1200, easing: 'ease-out-back', delay: 0 },
    [ANIMATION_TYPES.SLIDE_DOWN]:  { duration: 1200, easing: 'ease-out-back', delay: 0 },
    [ANIMATION_TYPES.SLIDE_LEFT]:  { duration: 1200, easing: 'ease-out-back', delay: 0 },
    [ANIMATION_TYPES.SLIDE_RIGHT]: { duration: 1200, easing: 'ease-out-back', delay: 0 },
    [ANIMATION_TYPES.SCALE_IN]:    { duration: 1000, easing: 'ease-out-back-strong', delay: 0 },
    [ANIMATION_TYPES.BOUNCE_IN]:   { duration: 1600, easing: 'bounce-out',    delay: 0 },
    [ANIMATION_TYPES.ROTATE_IN]:   { duration: 1200, easing: 'ease-out',      delay: 0 },
    [ANIMATION_TYPES.FLIP_IN]:     { duration: 1400, easing: 'ease-out-back', delay: 0 },
    [ANIMATION_TYPES.ZOOM_IN]:     { duration: 1200, easing: 'ease-out-back-strong', delay: 0 },
  
    [ANIMATION_TYPES.FLOAT]:       { duration: 6000, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.PULSE]:       { duration: 3000, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.ROTATE]:      { duration: 8000, easing: 'linear',        delay: 0 },
    [ANIMATION_TYPES.BOUNCE]:      { duration: 4000, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.SHAKE]:       { duration: 2000, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.WAVE]:        { duration: 4000, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.HEARTBEAT]:   { duration: 2400, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.FLASH]:       { duration: 2000, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.SWING]:       { duration: 3000, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.TADA]:        { duration: 2000, easing: 'ease-in-out',   delay: 0 },
  
    // Advanced
    [ANIMATION_TYPES.MORPH]:       { duration: 2400, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.GLOW]:        { duration: 2400, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.SHIMMER]:     { duration: 4000, easing: 'linear',        delay: 0 },
    [ANIMATION_TYPES.PARTICLE]:    { duration: 3200, easing: 'ease',          delay: 0 },
    [ANIMATION_TYPES.MAGNETIC]:    { duration: 1600, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.ELASTIC]:     { duration: 2000, easing: 'elastic-out',   delay: 0 },
    [ANIMATION_TYPES.SPIRAL]:      { duration: 6000, easing: 'linear',        delay: 0 },
    [ANIMATION_TYPES.ORBIT]:       { duration: 8000, easing: 'linear',        delay: 0 },
  
    // Special
    [ANIMATION_TYPES.NEON]:        { duration: 800,  easing: 'linear',        delay: 0 },
    [ANIMATION_TYPES.HOLOGRAM]:    { duration: 1600, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.GLITCH]:      { duration: 600,  easing: 'linear',        delay: 0 },
    [ANIMATION_TYPES.MATRIX]:      { duration: 3200, easing: 'linear',        delay: 0 },
    [ANIMATION_TYPES.FIRE]:        { duration: 1200, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.WATER]:       { duration: 2400, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.SMOKE]:       { duration: 4000, easing: 'linear',        delay: 0 },
    [ANIMATION_TYPES.SPARKLE]:     { duration: 1200, easing: 'ease-in-out',   delay: 0 },
    [ANIMATION_TYPES.RAINBOW]:     { duration: 12000,easing: 'linear',        delay: 0 },
    [ANIMATION_TYPES.GALAXY]:      { duration: 16000,easing: 'ease-in-out',   delay: 0 },
  };

// Utility function to get random animation
export const getRandomAnimation = (category = 'all') => {
    const categories = {
        entrance: Object.values(ANIMATION_TYPES).filter(type =>
            ['fadeIn', 'slideUp', 'slideDown', 'slideLeft', 'slideRight', 'scaleIn', 'bounceIn', 'rotateIn', 'flipIn', 'zoomIn'].includes(type)
        ),
        continuous: Object.values(ANIMATION_TYPES).filter(type =>
            ['float', 'pulse', 'rotate', 'bounce', 'shake', 'wave', 'heartbeat', 'flash', 'swing', 'tada'].includes(type)
        ),
        all: Object.values(ANIMATION_TYPES)
    };

    const availableTypes = categories[category] || categories.all;
    return availableTypes[Math.floor(Math.random() * availableTypes.length)];
};

// Export default configurations object for convenience
export default {
    ANIMATION_TYPES,
    ANIMATION_CONFIGS,
    Entrance_Animations,
    Continuous_Animations,
    Advanced_Animations,
    Special_Animations,
    getRandomAnimation,
};
